<template>
  <div class="file-upload">
    <div v-if="label"
         class="file-upload__label">{{ label }}</div>

    <div class="file-upload__content">
      <div v-if="value"
           class="file-upload__media-img-wrap">
        <FileShow :value="value"
                  class="file-upload__media-img  _cover"/>
        <BasePreloader v-if="pending"/>
      </div>

      <div :class="{'_drag-over': dragoverMixin}"
           @dragover.prevent="onDragoverMixin"
           @dragenter.prevent="onDragenterMixin"
           @dragleave.prevent="onDragleaveMixin"
           @drop.prevent="onDropMixin"
           @click="$refs.fileLogoInput.click()"
           class="file-upload__media-dropzone">
        <input class="d-none"
               type="file"
               ref="fileLogoInput"
               :accept="typeFilesLogo"
               @change="onFilesInputMixin">


        <button type="button"
                class="file-upload__media-btn-add base-btn base-btn--blue">
          <BasePreloader v-if="pending"/>
          <BaseSvg name="ico-plus"/>
        </button>
      </div>

      <button v-if="value && canDelete"
              type="button"
              @click="onDelete"
              class="file-upload__media-btn-delete">
        <BaseSvg name="ico-trash"/>
      </button>
    </div>
  </div>
</template>

<script>
  import fileUploadMixin from "@/mixins/fileUploadMixin"
  import {ALLOWED_IMAGES_EXTS} from '@/constants/files'
  import FileShow from "@/components/FileShow"

  export default {
    name: 'FileUpload',
    mixins: [fileUploadMixin],
    components: {
      FileShow
    },
    props: {
      label: String,
      value: Object,
      pending: Boolean,
      canDelete: Boolean
    },
    data() {
      return {
        uploadFileMethodNameMixin: ['onUpload'],
      }
    },
    computed: {
      typeFilesLogo() {
        const typesString = ALLOWED_IMAGES_EXTS.join(', .')
        return '.' + typesString
      }
    },
    methods: {
      onUpload(files) {
        this.$emit('input', files[0])
      },
      onDelete() {
        this.$emit('delete')
      }
    }
  }
</script>

<style lang="less">

</style>
